<template>
    <div>
        <div class="row" v-if="!isProfileCompleted">
            <div class="col-12">
                <div class="callout callout-danger p-3">
                    <h4>{{$t('message.profile_completion_title')}}</h4>
                    {{$t('message.profile_completion_message')}}
                    <br/>
                    <div class="text-right">
                        <router-link :to="{ name: 'SetupProfile'}" class="btn btn-primary">{{ $t('label.setup_my_profile')}}</router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <!-- ./col -->
            <div v-if="$hasPermission('tempvehicle.application.view')" class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-success">
                    <div class="inner">
                        <h3>{{ in_routing_applications.length }}</h3>
                        <p>{{ $t('label.enrouting')}}</p>
                    </div>
                    <div class="icon">
                        <fa :icon="fas.faFile" class="nav-icon"/>
                    </div>
                    <router-link :to="{ name: 'ApplicationList', query: { 'en_routing' : true }}" class="small-box-footer">{{ $t('label.more_info') }}<i class="fas fa-arrow-circle-right"></i></router-link>
                </div>
            </div>
            <div v-if="$hasPermission('tempvehicle.application.view')" class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-info">
                    <div class="inner">
                        <h3>{{total_declaration}}</h3>

                        <p>{{ $t('label.applications')}}</p>
                    </div>
                    <div class="icon">
                        <fa :icon="fas.faFileAlt" class="nav-icon"/>
                    </div>
                    <router-link :to="{ name: 'ApplicationList'}" class="small-box-footer">{{ $t('label.more_info') }}<i class="fas fa-arrow-circle-right"></i></router-link>
                </div>
            </div>

            <!-- ./col -->
            <div v-if="$hasPermission('tempvehicle.vehicle.view')" class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-warning">
                    <div class="inner">
                        <h3>{{vehicles.length}}</h3>

                        <p>{{ $t('label.vehicles')}}</p>
                    </div>
                    <div class="icon">
                        <fa :icon="fas.faCar" class="nav-icon"/>
                    </div>
                    <router-link :to="{ name: 'Vehicle'}" class="small-box-footer">{{ $t('label.more_info') }}<i class="fas fa-arrow-circle-right"></i></router-link>
                </div>
            </div>
            <!-- ./col -->
            <div v-if="$hasPermission('tempvehicle.driver.view')" class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box bg-danger">
                    <div class="inner">
                        <h3>{{drivers.length}}</h3>

                        <p>{{ $t('label.drivers')}}</p>
                    </div>
                    <div class="icon">
                        <fa :icon="fas.faUsers" class="nav-icon"/>
                    </div>
                    <router-link :to="{ name: 'Driver'}" class="small-box-footer">{{ $t('label.more_info') }}<i class="fas fa-arrow-circle-right"></i></router-link>
                </div>
            </div>
            <!-- ./col -->
        </div>
        <div v-if="$hasPermission('tempvehicle.application.view')" class="card card-primary card-outline">
            <div class="card-header">
                <h3 class="card-title">{{$t('label.declaration_status_today')}}</h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-widget="collapse"><fa :icon="fas.faMinus"/></button>
                </div>
            </div>
            <div class="card-body">
                <div class="table-responsive" v-if="applications.length > 0">
                    <table class="table table-bordered mb-0">
                        <thead>
                        <tr>
                            <th nowrap style="width: 1%;"></th>
                            <th nowrap>{{$t('label.lodgement_office_name')}}</th>
                            <th nowrap>{{$t('label.type')}}</th>
                            <th nowrap>{{$t('label.register_date')}}</th>
                            <th nowrap>{{$t('label.register_number')}}</th>
                            <th nowrap>{{$t('label.lodgement_office_date')}}</th>
                            <th nowrap>{{$t('label.destination_office_name')}}</th>
                            <th nowrap>{{$t('label.destination_office_date')}}</th>
                            <th nowrap style="width:80px;"></th>
                        </tr>
                        </thead>
                        <tbody  >
                        <tr v-for="(app, index) in applications" :key="index" :value="app.code" :style="'background-color: ' + getColor(app)">
                            <td>{{index+1}}</td>
                            <td :title="app.lodgement_office_name">{{app.lodgement_office_code}}</td>
                            <td>{{app.registration_type}}</td>
                            <td>{{app.registration_date}}</td>
                            <td>{{app.registration_year}} {{app.registration_serial}} {{app.registration_number}}</td>
                            <td>{{app.lodgement_office_date}}</td>
                            <td>{{app.destination_office_code}}</td>
                            <td>{{app.destination_office_date}}</td>
                            <td class="text-center">
                                <router-link v-if="$hasPermission('tempvehicle.application.view')" :to="{ name:'ViewApplication', params:{ uuid: app.uuid }}" :title="$t('label.view')" class="mr-2"><fa :icon="fas.faEye"/></router-link>
                                <router-link v-if="$hasPermission('tempvehicle.application.edit') && isEditable(app)" :to="{ name: 'EditApplication', params: { uuid : app.uuid }}">
                                    <fa class="nav-icon" :icon="['fas', 'edit']"></fa>
                                </router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="callout callout-success mb-0" v-else>
                    <label>{{$t('label.no_application')}}</label>
                </div>
            </div>
            <div class="card-footer" v-if="applications.length > 0">
                <paginate class="mb-0"
                          v-model="declaration_page"
                          :page-count="declaration_last_page"
                          :force-page="declaration_forcepage"
                          :page-range="3"
                          :margin-pages="2"
                          :click-handler="getApplicationStatus"
                          :container-class="'pagination float-right'"
                          :prev-text="'Prev'"
                          :next-text="'Next'"
                          :page-class="'page-item'"
                          :active-class="'active'"
                          :prev-link-class="'page-link'"
                          :next-link-class="'page-link'"
                          :page-link-class="'page-link'"
                          ref="declaration">
                </paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import {fas} from "@fortawesome/free-solid-svg-icons";
    // import {mapState} from "vuex";

    export default {
        props: {
            profile:{
                type: Object,
                default: null,
            }
        },
        computed: {
            fas() {
                return fas;
            },
            // ...mapState("user", ["user"])
        },
        data() {
            return {
                baseURI: "",
                applications : [],
                vehicles: [],
                drivers: [],
                total_declaration:0,
                isProfileCompleted: false,
                declaration_page: 1,
                declaration_forcepage: 1,
                declaration_pageNumber:1,
                declaration_current_page: 1,
                declaration_last_page: 0,
                declaration_order_by:'created_at',
                declaration_order_type:'asc',
                declaration_order_type_after_sort:'',

                in_routing_applications: [],
            }
        },
        watch: {
            drivers: function () {
                this.checkProfileCompletion('drivers');
            },
            vehicles: function () {
                this.checkProfileCompletion('vehicles');
            },
            profile: function () {
                this.checkProfileCompletion('profile');
            }
        },
        mounted() {
            this.getApplicationStatus();
            this.getVehicles();
            this.getDrivers();
            this.getInRoutingApplications();
            this.getTotalApplications();
        },
        methods:{
            getApplicationStatus(pageNumber = null, order_by = null, order_type=null){
                this.declaration_pageNumber = pageNumber;
                this.declaration_forcepage = pageNumber;
                let url = 'dashboard/applications?page='+pageNumber+'&order_by='+order_by+'&order_type='+order_type;
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.applications = response.data.data;
                    this.declaration_last_page = response.data.last_page;
                    this.declaration_current_page = response.data.current_page;
                    this.declaration_order_type_after_sort = order_type;
                    this.declaration_order_by = order_by;
                }).catch(error => {
                    console.warn(error);
                });
            },
            totalDeclaration(){
                let url = 'dashboard/total-declaration';
                GDCE_Client.requestApi("GET",url).then(response => {
                    if(response.status){
                      this.total_declaration = response.data;
                    }
                }).catch(error => {
                    console.warn(error);
                });
            },
            getVehicles() {
                let url = this.baseURI+'/vehicles';
                GDCE_Client.requestApi("GET",url).then(response => {
                    if(response.status){
                      this.vehicles = response.data.data;
                    }
                }).catch(error => {
                  console.warn(error);
                });
            },
            getDrivers() {
                let url = this.baseURI+'/drivers';
                GDCE_Client.requestApi("GET", url).then(response => {
                  if(response.status){
                    this.drivers = response.data.data;
                  }
                }).catch(error => {
                  console.warn(error);
                });
            },
            checkProfileCompletion(){
                if(this.profile && this.drivers.length>0 && this.vehicles.length>0){
                   if(this.profile.first_name == null
                       || this.profile.last_name == null
                       || this.profile.nationality == null
                       || this.profile.nationality_code == null
                       || this.profile.identity_card_number == null
                       || this.profile.identity_card_issued_date == null
                       || this.profile.identity_card_expired_date == null
                       || this.profile.address == null){

                       this.isProfileCompleted = false;
                   }else{
                       this.isProfileCompleted = true;
                   }
                }else{
                    this.isProfileCompleted = false;
                }

            },
            getColor(app){
                if(app.destination && app.destination.status === 'Approve'){
                    return "#cce5ff";
                }else if(app.destination && app.destination.status === 'Decline'){
                    return "#f8d7da";
                }else if(app.lodgement && app.lodgement.status === 'Approve'){
                    return "#d4edda";
                }else if(app.lodgement && app.lodgement.status === 'Decline'){
                    return "#fff3cd";
                }else {
                    return "white";
                }
            },
            getInRoutingApplications(){
                let url = 'dashboard/in-routing';
                GDCE_Client.requestApi("GET", url).then(response => {
                  if(response.status){
                    this.in_routing_applications = response.data;
                  }
                }).catch(error => {
                  console.warn(error);
                });
            },
            getTotalApplications(){
                let url = 'dashboard/total-declaration';
                GDCE_Client.requestApi("GET", url).then(response => {
                    this.total_declaration = response.data;
                }).catch(error => {
                  console.warn(error);
                });
            },
            isEditable(app){
              return !app.lodgement;
              // if(app.lodgement && app.lodgement.status === 'Decline'){
              //   return false;
              // }
              // return app.destination === null;
            }
        }
    }
</script>

<style scoped>
    .small-box .icon{
        font-size: 70px;
    }
    .callout .btn{
        text-transform: none;
        text-decoration: none;
    }
</style>